<template>
  <div class="container">
    <form action="post" @submit.prevent="updateNotification()" :class="{ 'was-validated': submitted}">
      <div class="form-group">
        <label for="">Datum</label>
        <input type="text" class="form-control" placeholder="åååå-mm-dd" v-model="notification.MessageDate" required>
      </div>

      <div class="form-group">
        <label>Namn</label>
        <select class="form-control" v-model="notification.UserId" required>
          <option value=""></option>
          <option v-for="u in users" :key="u.Id" :value="u.Id">{{ u.Firstname + ' ' + u.Lastname }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="note">Meddelande</label>
        <textarea class="form-control" id="note" rows="10" required v-model="notification.MessageText" placeholder="Meddelande"></textarea>
      </div>

      <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      submitted: false,
      notification: {},
      users: {}
    }
  },

  created () {
    appService.getUsers().then(res => this.users = res)
    appService.getNotification(this.id).then(notification => {
      notification.MessageDate = notification.MessageDate.substring(0, 10)
      this.notification = notification
    })
  },

  methods: {
    updateNotification () {
      appService.updateNotification(this.notification)
      .then(() => { this.$router.go(-1) })
      .catch(() => { this.error = 'Det gick inte att spara.' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/NotificationEdit.vue